import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyChallengesMostRecent: BaseKeyFunction = () => [
  "challenges-most-recent",
];
